import { useState } from "react";
import { useSignal } from "@preact/signals-react";

import CalendarTable from "./calendar/CalendarTable";
import ModalForm from "componentsv2/modal/ModalForm";
import Dropdown from "componentsv2/form/Dropdown";
import DateCard from "componentsv2/date/DateCard";
import GroupTags from "./calendar/GroupTags";
import Button from "componentsv2/button/Button";
import { layout as modelFolio } from "apps/HotelFrontdesk/models/folio";
import { layout as modelMaintenance } from "./modelMaintenance";
import { useStore } from "storev2/formStore";
import { PlusCircleIcon } from "components/Icons";
import "./calendar/calendar.css";

const models = {
  booking: modelFolio(),
  maintenance: modelMaintenance(),
};

function Calendar({ rooms }) {
  const selectedOC = useSignal(null);
  const selectedDate = useSignal(new Date());
  const openModal = useSignal(false);
  const layout = useSignal(null);
  const [reload] = useState(false);
  const recStoreId = useSignal(null);
  const { newRecord } = useStore();

  async function onClickAdd(model) {
    layout.value = models[model];
    if (model === "maintenance") {
      recStoreId.value = await newRecord(layout.value);
    }
    openModal.value = true;
  }

  async function handleClose() {
    openModal.value = false;
    // const { reset, trigger } = useWizardStore.getState();
    // await trigger(); // This is for reload table
    // await reset();
  }

  function onChange(name, value) {
    if (name === "planner_date") {
      selectedDate.value = value;
    } else {
      // const value_ = parse(value, fmtDate);
      // selectedDate.value = value_;
    }
  }

  const fieldDate = {
    name: "planner_date",
    // labeled: false,
    onChange: onChange,
  };

  const fieldOC = {
    label: "hotel.rack.operation_center",
    name: "operation_center",
    type: "many2one",
    model: "company.operation_center",
    recSearch: () => [],
    onChange: onChange,
    searchable: true,
    preloaded: true,
    // preOptions: getSections,
  };

  return (
    <div className="w-full">
      <div className="flex h-20 space-x-12 w-full z-20">
        <p className="my-auto text-4xl font-bold ml-6 text-sky-800">RACK</p>
        <div className="my-auto">
          <DateCard data={selectedDate} {...fieldDate} />
        </div>
        <div className="flex my-auto gap-x-4 w-3/5 justify-center items-center">
          <GroupTags />
          {/* <Button
            onClick={() => onClickAdd("booking")}
            name="add_booking"
            content="hotel.calendar.add_booking"
            // iconRight="fi fi-bs-add"
            iconRight={<PlusCircleIcon className="w-5 h-5 fill-current" />}
          />*/}
          <Dropdown {...fieldOC} data={selectedOC} />
          <Button
            onClick={() => onClickAdd("maintenance")}
            name="add_maintenance"
            content="hotel.rack.add_maintenance"
            iconRight={<PlusCircleIcon className="w-5 h-5 fill-current" />}
            color="black"
            size="w-full md:w-40"
          />
          <ModalForm
            storeId={recStoreId}
            openModal={openModal}
            onClose={handleClose}
            layout={layout.value}
          />
        </div>
      </div>
      {rooms.size > 0 && (
        <CalendarTable
          selectedDate={selectedDate}
          rooms={rooms}
          reload={reload}
        />
      )}
    </div>
  );
}

export default Calendar;
